/*
 * Copyright (c) 2014-2023 Inovalon, Inc. All Rights Reserved.
 * This computer program is CONFIDENTIAL and a TRADE SECRET of Inovalon, Inc.
 * The receipt or possession of this program does not convey any rights to use, reproduce or disclose
 * its contents in whole or in part, without the specific written consent of Inovalon, Inc.
 * Any use, reproduction or disclosure of this program without the express written consent of Inovalon, Inc.
 * is a violation of the copyright laws and may subject you to criminal prosecution.
 */
import { injectable } from 'inversify'
import { injectProperty } from '../../arc/configuration/ServiceLocator'
import { ICoverageDiscoveryTransactionStateManager, ICoverageDiscoveryTransaction } from './contracts'
import { ICoverageDiscoveryTransactionApiClient } from '../CoverageDiscoveryTransactionApiClient/contracts'
import { action } from 'mobx'

@injectable()
export class CoverageDiscoveryTransactionStateManager implements ICoverageDiscoveryTransactionStateManager {
	@injectProperty('ICoverageDiscoveryTransactionApiClient')
	public CoverageDiscoveryTransactionApiClient!: ICoverageDiscoveryTransactionApiClient

	@action get(id: number): Promise<ICoverageDiscoveryTransaction> {
		return this.CoverageDiscoveryTransactionApiClient.get(id)
			.then(response => response)
			.catch(error => {
				if (error.response && error.response.status === 404) {
					throw new Error('Either the response does not exist or you do not have permission to view it.')
				} else {
					throw new Error('An error occurred while loading the response.')
				}
			})
	}
}
